/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmploymentSkills } from '../../models/employment-skills';

export interface FindAllEmploymentSkills$Params {
  ids?: Array<number>;
  ignoreIds?: Array<number>;
  searchQuery?: string;
  pageSize?: number;
  page?: number;
  extended?: boolean;
  skipTranslation?: boolean;
}

export function findAllEmploymentSkills(http: HttpClient, rootUrl: string, params?: FindAllEmploymentSkills$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmploymentSkills>>> {
  const rb = new RequestBuilder(rootUrl, findAllEmploymentSkills.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
    rb.query('ignoreIds', params.ignoreIds, {});
    rb.query('searchQuery', params.searchQuery, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('page', params.page, {});
    rb.query('extended', params.extended, {});
    rb.query('skipTranslation', params.skipTranslation, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmploymentSkills>>;
    })
  );
}

findAllEmploymentSkills.PATH = '/employment-skill';
